module.exports = __webpack_public_path__ + "img/logo-tab.0a218cc5.png";